import { Link } from '@material-ui/core';
import React from 'react';

export const parseLinks = (text, { markdown = false, linkProps = {} } = {}) => {
  if (!text) return null;

  const regex = markdown ? /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g : /(https?:\/\/[^\s)]+)/g;

  const parts = [];
  let match;
  let key = 0;
  let lastIndex = 0;

  while ((match = regex.exec(text)) !== null) {
    const [full, linkText, url] = markdown ? match : [match[0], match[0], match[0]];

    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }

    parts.push(
      <Link
        key={`link-${key++}`}
        color='inherit'
        underline='always'
        href={url}
        target='_blank'
        rel='noopener noreferrer'
        {...linkProps}
      >
        {linkText}
      </Link>,
    );

    lastIndex = match.index + full.length;
  }

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  // Retourne soit un tableau, soit directement le texte si pas de lien
  return parts.length === 1 && typeof parts[0] === 'string' ? parts[0] : parts;
};
